// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiSpecialtyPharmacyResult {
    static getAttributeTypeMap() {
        return PharmacyBiSpecialtyPharmacyResult.attributeTypeMap;
    }
}
PharmacyBiSpecialtyPharmacyResult.discriminator = undefined;
PharmacyBiSpecialtyPharmacyResult.additionalProperties = false;
PharmacyBiSpecialtyPharmacyResult.attributeTypeMap = [
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiSpecialtyPharmacyResult.js.map